import { setComponentMapOverrides } from '@jutro/uiconfig';

import FNOLBOPWizard from './FNOLBOPWizard';
import FNOLBOWhatPage from './pages/What/WhatPage';
import FNOLBOPBuildingPage from './pages/BOPBuilding/BuildingPage';
import FNOLBOPDetailsPage from './pages/Details/DetailsPage';

setComponentMapOverrides(
    {
        FNOLBOPWizard: { component: 'FNOLBOPWizard' },
        FNOLBOWhatPage: { component: 'FNOLBOWhatPage' },
        FNOLBOPBuildingPage: { component: 'FNOLBOPBuildingPage' },
        FNOLBOPDetailsPage: { component: 'FNOLBOPDetailsPage' }
    },
    {
        FNOLBOPWizard,
        FNOLBOWhatPage,
        FNOLBOPBuildingPage,
        FNOLBOPDetailsPage
    }
);

export {
    FNOLBOPWizard as default
};
